export default function BlueButton({
  label,
  children,
  size = "md",
  disabled = false,
  onClick,
  className = "",
  variant = "primary", // 👈 NEW
}) {
  const sizeClasses = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-5 py-3 text-base",
  };

  const variantStyles = {
    primary: "#0B5ED7", // blue
    success: "#16a34a", // green
    danger: "#dc2626",  // red
    warning: "#f59e0b", // amber
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-xl font-semibold text-white
        ${sizeClasses[size]}
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"}
        ${className}
      `}
      style={{ backgroundColor: variantStyles[variant] }}
    >
      {label || children}
    </button>
  );
}



// export default function BlueButton({
//   label,
//   children,
//   size = "md",
//   disabled = false,
//   onClick,
//   className = "",
// }) {
//   const sizeClasses = {
//     sm: "px-3 py-1 text-sm",
//     md: "px-4 py-2 text-sm",
//     lg: "px-5 py-3 text-base",
//   };

//   return (
//     <button
//       onClick={onClick}
//       disabled={disabled}
//       className={`
//         rounded-xl font-semibold text-white
//         ${sizeClasses[size]}
//         ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"}
//         ${className}
//       `}
//       style={{ backgroundColor: "#0B5ED7" }}
//     >
//       {label || children}
//     </button>
//   );
// }




// export default function BlueButton({ children, className = "", onClick }) {
//   return (
//     <button
//       onClick={onClick}
//       className={`rounded-xl px-3 py-1 text-sm font-semibold text-white ${className}`}
//       style={{ backgroundColor: "#0B5ED7" }}
//     >
//       {children}
//     </button>
//   );
// }